import { render, staticRenderFns } from "./RecipientForm.vue?vue&type=template&id=0d0cc3f3&scoped=true&lang=pug&"
import script from "./RecipientForm.vue?vue&type=script&lang=js&"
export * from "./RecipientForm.vue?vue&type=script&lang=js&"
import style0 from "./RecipientForm.vue?vue&type=style&index=0&id=0d0cc3f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0cc3f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VTab,VTabItem,VTabs,VTabsItems})
